/**
 * A frozen empty array that can be used as a stable default value to avoid
 * creating a new `[]` reference on every render, which would break
 * React.memo / useMemo shallow comparisons.
 *
 * Typed as `readonly never[]` so it's assignable to any `readonly T[]` or `T[]`
 * without casts.
 */
export const EMPTY_ARRAY: readonly never[] = Object.freeze([]);

/**
 * A frozen empty Map that can be used as a stable default value to avoid
 * creating a new `new Map()` reference on every render, which would break
 * React.memo / useMemo shallow comparisons.
 *
 * Typed as `ReadonlyMap<never, never>` so it's assignable to any
 * `ReadonlyMap<K, V>` or `Map<K, V>` without casts.
 */
export const EMPTY_MAP: ReadonlyMap<never, never> = Object.freeze(new Map<never, never>());
